module.exports = __webpack_public_path__ + "static/img/new-55.aa846e8f.jpg";